import { useEffect } from 'react';
import {
  SelectSessionButton,
} from './KeysAndSigningUI';
import {
  Header,
} from './MonacottoMiscUI';
import {
  TextLine3,
} from './UtilComponents';
import {
  useGlobalStateSelector,
  words,
  priceDigit,
} from './globalState';
import {
  handleClickDefaultExhibit,
  handleClickClearExhibit,
  handleClickSignExhibit,
  handleClickSendToken,
} from './exhibit';
import {
  keepKeyPairsInMemory,
  handleClickNfc,
  getSecretsFromNativeApp,
  handleClickMpurse,
} from './keysAndSigning';
import {
  handleClickAddressHistory,
} from './monacottoMisc';
import {
  handleClickScanQr,
} from './utils';
import iconMpurse from './mpurse.png';
import iconList from './format_list_bulleted_FILL0_wght400_GRAD0_opsz48.svg';
import iconSign from './history_edu_FILL0_wght400_GRAD0_opsz48.svg';

// EXHIBIT
function Exhibit() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );

  let exhibitNo;

  if (state.exhibit.exhibitNo !== undefined && state.exhibit.exhibitNo !== null && state.exhibit.exhibitNo !== '') {
    exhibitNo = state.exhibit.exhibitNo;
  }
  else {
    exhibitNo = '-';
  }

  useEffect( () => {
    dispatch({ type: 'setState', key: 'exhibit',
      value: {
        exhibitNo: '',
        addressMain: state.exhibit.addressMain,
        // addressMainCoinType: 'mona',
        addressCardFrom: state.exhibit.addressCardFrom,
        addressPayProceedsTo: state.exhibit.addressPayProceedsTo,
        tokenName: state.exhibit.tokenName,
        amountToSell: state.exhibit.amountToSell,
        priceMona: state.exhibit.priceMona,
        signatureByAddressMain: '',
        signatureByAddressCardFrom: '',
        disabled: false,
        status: 'waitingForSignature',
      }
    });
  }, []);


  return (
    <div>
      {/* PC */}
      <div className='visibleMiddleOrMore' >
        <Header screen='exhibit' />
        <div className='flexRow justifyContentCenter' >
          <div className='flexColumn alignItemsFlexStart' >
            <div className='flexRow justifyContentSpaceBetween alignItemsCenter marginTop1 widthMax'>
              <div>
                { 'No. ' + exhibitNo }
              </div>
              <div>
                <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2' tabindex='0' onClick={ () => { handleClickDefaultExhibit(state, dispatch) } }>
                  {words.default[state.language]}
                </button>
                <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2' tabindex='0' onClick={ () => { handleClickClearExhibit(state, dispatch) } }>
                  {words.clear[state.language]}
                </button>
              </div>
            </div>
            <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
              <TextLine3 fieldName='exhibitAddressMain' keys={['exhibit', 'addressMain']} face={words.addressMain[state.language]} tooltip={true} disabled={state.exhibit.disabled} />
              <SelectSessionButton loginEnabled={true} setConfigure={true} />
              <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['exhibit', 'addressMain']) }>
                <img className='size2x2' src={iconMpurse} alt='mpurse' />
              </button>
              <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['exhibit', 'addressMain']) }>
                <img className='size2x2' src={iconList} alt='list' />
              </button>
            </div>
            <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
              <TextLine3 fieldName='exhibitaddressCardFrom' keys={['exhibit', 'addressCardFrom']} face={words.addressCardFrom[state.language]} tooltip={true} disabled={state.exhibit.disabled} />
              <SelectSessionButton stateKeysToSetAddress={[['exhibit', 'addressCardFrom']]} stateKeysToSetUserName={[]} />
              <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['exhibit', 'addressCardFrom']) }>
                <img className='size2x2' src={iconMpurse} alt='mpurse' />
              </button>
              <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['exhibit', 'addressCardFrom']) }>
                <img className='size2x2' src={iconList} alt='list' />
              </button>
            </div>
            <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
              <TextLine3 fieldName='exhibitaddressPayProceedsTo' keys={['exhibit', 'addressPayProceedsTo']} face={words.addressPayProceedsTo[state.language]} tooltip={true} disabled={state.exhibit.disabled} />
              <SelectSessionButton stateKeysToSetAddress={[['exhibit', 'addressPayProceedsTo']]} stateKeysToSetUserName={[]} />
              <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['exhibit', 'addressPayProceedsTo']) }>
                <img className='size2x2' src={iconMpurse} alt='mpurse' />
              </button>
              <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['exhibit', 'addressPayProceedsTo']) }>
                <img className='size2x2' src={iconList} alt='list' />
              </button>
            </div>
            <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
              <TextLine3 fieldName='exhibittokenName' keys={['exhibit', 'tokenName']} face={words.tokenName[state.language]} tooltip={true} disabled={state.exhibit.disabled} />
            </div>
            <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
              <TextLine3 fieldName='exhibitamountToSell' keys={['exhibit', 'amountToSell']} face={words.amount[state.language]} type='setStateMultiLayersNum' disabled={state.exhibit.disabled} />
            </div>
            <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
              <TextLine3 fieldName='exhibitpriceMona' keys={['exhibit', 'priceMona']} face={words.unitPriceMonaWithUnit[state.language]}
                type='setStateMultiLayersFloat' adjustType='round' adjustExp={priceDigit} disabled={state.exhibit.disabled}
              />
            </div>
            {
              (state.exhibit.signatureByAddressMain === undefined ||
               state.exhibit.signatureByAddressMain === null ||
               state.exhibit.signatureByAddressMain === '') ?
                <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
                  onClick={ async () => {
                    const result = await handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressMain');

                    if (result?.message === 'nfcRequired') {
                      const callback = (keyPairs) => {
                        handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressMain', keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      };

                      handleClickNfc(state, dispatch, callback);
                    }
                    else if (result?.message === 'nfcNativeRequired') {
                      const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                      handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressMain', keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                    }
                    else if (result?.message === 'bcRequired') {
                      const callback = (keyPairs) => {
                        handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressMain', keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      };

                      handleClickScanQr(state, dispatch, callback);
                    }
                  }}
                >
                  <div>
                    {words.signByMainAddress[state.language]}
                  </div>
                  <img className='size2x2' src={iconSign} alt='' />
                </button>
              : null
            }
            {
              (state.exhibit.signatureByAddressMain !== undefined &&
               state.exhibit.signatureByAddressMain !== null &&
               state.exhibit.signatureByAddressMain !== '' &&
               (state.exhibit.signatureByAddressCardFrom === undefined ||
                state.exhibit.signatureByAddressCardFrom === null ||
                state.exhibit.signatureByAddressCardFrom === '')) ?
                <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
                  onClick={ async () => {
                    const result = await handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom');

                    if (result?.message === 'nfcRequired') {
                      const callback = (keyPairs) => {
                        handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom', keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      };

                      handleClickNfc(state, dispatch, callback);
                    }
                    else if (result?.message === 'nfcNativeRequired') {
                      const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                      handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom', keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                    }
                    else if (result?.message === 'bcRequired') {
                      const callback = (keyPairs) => {
                        handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom', keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      };

                      handleClickScanQr(state, dispatch, callback);
                    }
                  }}
                >
                  <div>
                    {words.signByAddressYouSendCardsFrom[state.language]}
                  </div>
                  <img className='size2x2' src={iconSign} alt='' />
                </button>
              : null
            }
            {
              state.exhibit.status === 'waitingForToken' ?
                <button className='button2 borderRadius2 riseOut2' tabindex='0'
                  onClick={ async () => {
                    const result = await handleClickSendToken(state, dispatch);

                    if (result?.message === 'nfcRequired') {
                      const callback = (keyPairs) => {
                        handleClickSendToken(state, dispatch, keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      };

                      handleClickNfc(state, dispatch, callback);
                    }
                    else if (result?.message === 'nfcNativeRequired') {
                      const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                      handleClickSendToken(state, dispatch, keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                    }
                    else if (result?.message === 'bcRequired') {
                      const callback = (keyPairs) => {
                        handleClickSendToken(state, dispatch, keyPairs);
                        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                      };

                      handleClickScanQr(state, dispatch, callback);
                    }
                  }}
                >
                  {words.sendCards[state.language]}
                </button>
              : null
            }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn alignItemsCenter ' >
        <Header screen='exhibit' />
        <div className='flexColumn alignItemsCenter marginTopBottom1'>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter marginTop1 widthMax'>
            <div>
              { 'No. ' + exhibitNo }
            </div>
            <div>
              <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2' tabindex='0' onClick={ () => { handleClickDefaultExhibit(state, dispatch) } }>
                {words.default[state.language]}
              </button>
              <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2' tabindex='0' onClick={ () => { handleClickClearExhibit(state, dispatch) } }>
                {words.clear[state.language]}
              </button>
            </div>
          </div>
          <div className='flexColumn alignItemsFlexStart' >
            <div className='flexColumn justifyContentFlexStart marginTop1 '>
              <TextLine3 fieldName='exhibitAddressMain' keys={['exhibit', 'addressMain']} face={words.addressMain[state.language]} tooltip={true} disabled={state.exhibit.disabled} />
              <div className='flexRow justifyContentFlexStart alignItemsCenter' >
                <SelectSessionButton loginEnabled={true} setConfigure={true} />
                <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['exhibit', 'addressMain']) }>
                  <img className='size2x2' src={iconMpurse} alt='mpurse' />
                </button>
                <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['exhibit', 'addressMain']) }>
                  <img className='size2x2' src={iconList} alt='list' />
                </button>
              </div>
            </div>
            <div className='flexColumn justifyContentFlexStart marginTop1 '>
              <TextLine3 fieldName='exhibitaddressCardFrom' keys={['exhibit', 'addressCardFrom']} face={words.addressCardFrom[state.language]} tooltip={true} disabled={state.exhibit.disabled} />
              <div className='flexRow justifyContentFlexStart alignItemsCenter' >
                <SelectSessionButton stateKeysToSetAddress={[['exhibit', 'addressCardFrom']]} stateKeysToSetUserName={[]} />
                <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['exhibit', 'addressCardFrom']) }>
                  <img className='size2x2' src={iconMpurse} alt='mpurse' />
                </button>
                <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['exhibit', 'addressCardFrom']) }>
                  <img className='size2x2' src={iconList} alt='list' />
                </button>
              </div>
            </div>
            <div className='flexColumn justifyContentFlexStart marginTopBottom1 '>
              <TextLine3 fieldName='exhibitaddressPayProceedsTo' keys={['exhibit', 'addressPayProceedsTo']} face={words.addressPayProceedsTo[state.language]} tooltip={true} disabled={state.exhibit.disabled} />
              <div className='flexRow justifyContentFlexStart alignItemsCenter' >
                <SelectSessionButton stateKeysToSetAddress={[['exhibit', 'addressPayProceedsTo']]} stateKeysToSetUserName={[]} />
                <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['exhibit', 'addressPayProceedsTo']) }>
                  <img className='size2x2' src={iconMpurse} alt='mpurse' />
                </button>
                <button className='button1' disabled={state.exhibit.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['exhibit', 'addressPayProceedsTo']) }>
                  <img className='size2x2' src={iconList} alt='list' />
                </button>
              </div>
            </div>
            <TextLine3 fieldName='exhibittokenName' keys={['exhibit', 'tokenName']} face={words.tokenName[state.language]} tooltip={true} disabled={state.exhibit.disabled} />
            <TextLine3 fieldName='exhibitamountToSell' keys={['exhibit', 'amountToSell']} face={words.amount[state.language]} type='setStateMultiLayersNum' disabled={state.exhibit.disabled} />
            <TextLine3 fieldName='exhibitpriceMona' keys={['exhibit', 'priceMona']} face={words.unitPriceMonaWithUnit[state.language]}
              type='setStateMultiLayersFloat' adjustType='round' adjustExp={priceDigit} disabled={state.exhibit.disabled}
            />
          </div>
          {
            (state.exhibit.signatureByAddressMain === undefined ||
             state.exhibit.signatureByAddressMain === null ||
             state.exhibit.signatureByAddressMain === '') ?
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
                onClick={ async () => {
                  const result = await handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressMain');

                  if (result?.message === 'nfcRequired') {
                    const callback = (keyPairs) => {
                      handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressMain', keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                    };

                    handleClickNfc(state, dispatch, callback);
                  }
                  else if (result?.message === 'nfcNativeRequired') {
                    const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                    handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressMain', keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  }
                  else if (result?.message === 'bcRequired') {
                    const callback = (keyPairs) => {
                      handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressMain', keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                    };

                    handleClickScanQr(state, dispatch, callback);
                  }
                }}
              >
                <div>
                  {words.signByMainAddress[state.language]}
                </div>
                <img className='size2x2' src={iconSign} alt='sign' />
              </button>
            : null
          }
          {
            (state.exhibit.signatureByAddressMain !== undefined &&
             state.exhibit.signatureByAddressMain !== null &&
             state.exhibit.signatureByAddressMain !== '' &&
             (state.exhibit.signatureByAddressCardFrom === undefined ||
              state.exhibit.signatureByAddressCardFrom === null ||
              state.exhibit.signatureByAddressCardFrom === '')) ?
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
                onClick={ async () => {
                  const result = await handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom');

                  if (result?.message === 'nfcRequired') {
                    const callback = (keyPairs) => {
                      handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom', keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                    };

                    handleClickNfc(state, dispatch, callback);
                  }
                  else if (result?.message === 'nfcNativeRequired') {
                    const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                    handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom', keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  }
                  else if (result?.message === 'bcRequired') {
                    const callback = (keyPairs) => {
                      handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom', keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                    };

                    handleClickScanQr(state, dispatch, callback);
                  }
                }}
              >
                <div>
                  {words.signByAddressYouSendCardsFrom[state.language]}
                </div>
                <img className='size2x2' src={iconSign} alt='sign' />
              </button>
            : null
          }
          {
            state.exhibit.status === 'waitingForToken' ?
              <button className='button2 borderRadius2 riseOut2' tabindex='0'
                onClick={ async () => {
                  const result = await handleClickSendToken(state, dispatch);

                  if (result?.message === 'nfcRequired') {
                    const callback = (keyPairs) => {
                      handleClickSendToken(state, dispatch, keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                    };

                    handleClickNfc(state, dispatch, callback);
                  }
                  else if (result?.message === 'nfcNativeRequired') {
                    const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

                    handleClickSendToken(state, dispatch, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                  }
                  else if (result?.message === 'bcRequired') {
                    const callback = (keyPairs) => {
                      handleClickSendToken(state, dispatch, keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
                    };

                    handleClickScanQr(state, dispatch, callback);
                  }
                }}
              >
                {words.sendCards[state.language]}
              </button>
            : null
          }
        </div>
      </div>
    </div>
  );
}

export {
  Exhibit,
};